import posthog from 'posthog-js';
import { analytics } from '@/analytics/client';

type PostHogEnv = {
  VITE_POSTHOG_KEY?: string;
  VITE_POSTHOG_HOST?: string;
};

let didInitialize = false;

function getPostHogEnv() {
  return import.meta.env as PostHogEnv;
}

export function initPostHogAnalytics() {
  if (didInitialize || typeof window === 'undefined') {
    return analytics.getStatus();
  }

  const env = getPostHogEnv();
  const apiKey = env.VITE_POSTHOG_KEY?.trim();

  if (!apiKey) {
    analytics.configure(null, { disabledReason: 'missing_env' });
    return analytics.getStatus();
  }

  didInitialize = true;
  posthog.init(apiKey, {
    api_host: env.VITE_POSTHOG_HOST?.trim() || 'https://us.i.posthog.com',
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: true,
    disable_session_recording: true,
    mask_all_element_attributes: true,
    mask_all_text: true,
    persistence: 'localStorage+cookie',
    respect_dnt: true,
  });

  analytics.configure({
    capture: (eventName, properties) => posthog.capture(eventName, properties),
    identify: (distinctId, properties) => posthog.identify(distinctId, properties),
    reset: () => posthog.reset(),
    opt_in_capturing: () => posthog.opt_in_capturing(),
    opt_out_capturing: () => posthog.opt_out_capturing(),
  });

  return analytics.getStatus();
}
